export default __webpack_public_path__ + "static/media/deshacer.14b872e9.svg";